module.exports = __webpack_public_path__ + "static/media/privacy.9a35cd5e.txt";